import { render, staticRenderFns } from "./EtiquetasAgendadas.vue?vue&type=template&id=2c618d06"
import script from "./EtiquetasAgendadas.vue?vue&type=script&lang=js"
export * from "./EtiquetasAgendadas.vue?vue&type=script&lang=js"
import style0 from "./EtiquetasAgendadas.vue?vue&type=style&index=0&id=2c618d06&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports